<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('retailSale.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('retailSale.pageTitle'), href: '/retail-sales' },
          { text: $t('create'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('retailSale.actionForm') }}</legend>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2">{{
                                $t('retailSale.student')
                              }}</label>
                              <div class="col-md-6">
                                <a-select
                                  v-model="model.student_id"
                                  show-search
                                  :placeholder="$t('search')"
                                  style="width: 100%"
                                  :default-active-first-option="false"
                                  :show-arrow="false"
                                  :filter-option="false"
                                  :not-found-content="null"
                                  :loading="fetching_student"
                                  @search="handleSearchStudent"
                                  @change="onStudentChange"
                                >
                                  <a-select-option
                                    v-for="student in studentResources"
                                    :key="student.student_id"
                                  >
                                    {{
                                      student.full_name_en +
                                      ' (' +
                                      student.gender +
                                      ')'
                                    }}
                                  </a-select-option>
                                </a-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2 required">{{
                                $t('retailSale.date')
                              }}</label>
                              <div class="col-md-6">
                                <a-date-picker
                                  v-model="model.stock_out_date"
                                  format="DD-MM-YYYY"
                                  valueFormat="DD-MM-YYYY"
                                  :placeholder="$t('selectDate')"
                                  style="width: 100%"
                                />
                                <div
                                  class="validate"
                                  v-if="errors.has('stock_out_date')"
                                >
                                  {{ errors.first('stock_out_date') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2">{{
                                $t('retailSale.remark')
                              }}</label>
                              <div class="col-md-6">
                                <textarea
                                  v-model.trim="model.remarks"
                                  rows="3"
                                  class="form-control"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 ts-space-y-3">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2">{{
                                $t('invoice.paymentMethod')
                              }}</label>
                              <div class="col-md-6">
                                <select
                                  class="form-control"
                                  v-model="model.payment_method_id"
                                  @change="onPaymentMethodChange"
                                >
                                  <option
                                    v-for="(p, index) in paymentMethods"
                                    :key="index"
                                    :value="p.id"
                                  >
                                    {{ p.label }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label
                                class="col-form-label col-md-2"
                                :class="
                                  model.payment_method_id == 1 ? '' : 'required'
                                "
                                >{{ $t('invoice.bankName') }}</label
                              >
                              <div class="col-md-6">
                                <select
                                  v-model="model.bank_id"
                                  class="form-control"
                                  :disabled="model.payment_method_id == 1"
                                  @change="onBankProfileChange"
                                >
                                  <option
                                    v-for="(b, index) in bankProfiles"
                                    :value="b.bank_id"
                                    :key="index"
                                  >
                                    {{ b.bank_name }}
                                  </option>
                                </select>
                                <div
                                  class="validate"
                                  v-if="errors.has('bank_id')"
                                >
                                  {{ errors.first('bank_id') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label
                                class="col-form-label col-md-2"
                                :class="
                                  model.payment_method_id == 1 ? '' : 'required'
                                "
                                >{{ $t('invoice.bankAccount') }}</label
                              >
                              <div class="col-md-6">
                                <select
                                  v-model="model.account_id"
                                  class="form-control"
                                  :disabled="model.payment_method_id == 1"
                                >
                                  <option
                                    v-for="(b, index) in bankAccounts"
                                    :value="b.account_id"
                                    :key="index"
                                  >
                                    {{ b.account_number }} |{{ b.account_name }}
                                  </option>
                                </select>
                                <div
                                  class="validate"
                                  v-if="errors.has('account_id')"
                                >
                                  {{ errors.first('account_id') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row ts-mt-3">
                    <div class="col-md-12">
                      <panel :title="$t('retailSale.item')">
                        <item-detail v-model="model" :validate="errors" />
                        <div class="validate" v-if="errors.has('detail_list')">
                          {{ errors.first('detail_list') }}
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-12 text-right">
                            <ts-button
                              class="mr-2"
                              @click.prevent="
                                $router.push({ name: 'retail-sale' })
                              "
                              >{{ $t('cancel') }}</ts-button
                            >
                            <ts-button
                              outline
                              color="primary"
                              :waiting="waiting_print"
                              @click.prevent="savePrint"
                              >{{ $t('savePrint') }}</ts-button
                            >
                            <ts-button
                              class="ml-2"
                              color="primary"
                              :waiting="waiting"
                              @click.prevent="save"
                              >{{ $t('save') }}</ts-button
                            >
                          </div>
                        </div>
                      </panel>
                    </div>
                  </div>
                  <!-- preview pdf -->
                  <a-modal
                    v-model="preview_pdf"
                    :title="$t('pdf')"
                    @cancel="() => (preview_pdf = false)"
                    width="35%"
                    :maskClosable="false"
                    :footer="null"
                    :zIndex="1020"
                  >
                    <preview-pdf-component
                      :src="src"
                      :waiting="waiting_print"
                    />
                  </a-modal>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import ItemDetail from './components/item-detail'
import PreviewPdfComponent from './components/pdf-preview'

export default {
  name: 'retailSaleCreate',
  components: {
    ItemDetail,
    PreviewPdfComponent
  },
  data () {
    this.handleSearchStudent = debounce(this.handleSearchStudent, 800)
    return {
      waiting: false,
      waiting_print: false,
      model: {
        stock_out_date: moment().format('DD-MM-YYYY'),
        payment_method_id: 1,
        bank_id: null,
        account_id: null,
        student_id: null,
        remarks: null,
        detail_list: []
      },
      bank_id: null,
      account_id: null,
      studentResources: [],
      bank: [],
      bankAccount: [],
      fetching_student: false,
      preview_pdf: false,
      src: null,
      errors: new Errors()
    }
  },
  created () {
    this.getBankProfile()
  },
  computed: {
    paymentMethods () {
      return [
        { id: 1, label: 'Cash' },
        { id: 2, label: 'Bank QR' },
        { id: 3, label: 'Bank Transfer' },
        { id: 4, label: 'Credit Card' }
      ]
    },
    bankProfiles () {
      return this.bank
    },
    bankAccounts () {
      return this.bankAccount
    }
  },
  methods: {
    ...mapActions('retailSale', [
      'searchingStudent',
      'store',
      'bankStudent',
      'bankProfile'
    ]),
    save () {
      this.errors = new Errors()
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'retail-sale' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    savePrint () {
      this.errors = new Errors()
      this.waiting_print = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.preview_pdf = true
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_print = false
        })
    },
    onStudentChange () {
      this.model.bank_id = null
      this.model.account_id = null
      this.bank_id = null
      this.account_id = null
      this.bankStudent(this.model.student_id).then(response => {
        let bank = response.data
        if (bank) {
          if (this.model.payment_method_id == 1) {
            this.bank_id = bank.bank_id
            this.onBankProfileChange()
            this.account_id = bank.account_id
          } else {
            this.model.bank_id = bank.bank_id
            this.onBankProfileChange()
            this.model.account_id = bank.account_id
          }
        }
      })
    },
    async getBankProfile () {
      await this.bankProfile()
        .then(response => {
          this.bank = response.data
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onPaymentMethodChange () {
      if (this.model.payment_method_id == 1) {
        this.model.bank_id = null
        this.model.account_id = null
      } else {
        this.model.bank_id = this.bank_id
        this.model.account_id = this.account_id
      }
      // else {
      //   if (this.bank) {
      //     var b = this.bank.find(b => parseInt(b.is_default) == 1)
      //     this.model.bank_id = b.bank_id
      //   }
      // }
    },
    onBankProfileChange () {
      if (this.model.payment_method_id == 1) {
        var b = this.bank.find(b => b.bank_id == this.bank_id)
      } else {
        var b = this.bank.find(b => b.bank_id == this.model.bank_id)
      }
      if (b) {
        this.bankAccount = b.bank_accounts
      }
    },
    handleSearchStudent (value) {
      this.studentResources = []
      this.fetching_student = true
      this.searchingStudent({
        search: value,
        fields: {
          setup_student_profiles: 'student_id,first_name_en,last_name_en,gender'
        },
        page: -1
      })
        .then(response => {
          this.studentResources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_student = false
        })
    },
    clearInput () {
      ;(this.model.stock_out_date = moment()),
        (this.model.student_id = null),
        (this.model.remarks = null),
        (this.model.detail_list = [])
    }
  }
}
</script>

<style lang="css" scoped>
.panel {
  margin-bottom: 0 !important;
}
</style>
